import * as React from 'react';
export const IcVideoEnd = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.6 7.8l-2.6 2V9c.015-.17.015-.34 0-.51L20.49 5a1.055 1.055 0 00-1.148-1.719c-.128.053-.244.13-.342.229L3.51 19A1.053 1.053 0 105 20.49L7.44 18H14a3 3 0 003-3v-.75l2.6 1.95A1.5 1.5 0 0022 15V9a1.5 1.5 0 00-2.4-1.2zM5 6a3 3 0 00-3 3v6a3 3 0 00.77 2l11-11H5z'
      fill='currentColor'
    />
  </svg>
);
